import { type DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
    colors: {
        black: '#222',
        white: '#fff',
        dark: '#212026',
        light: '#f9f9f9',
        primary: '#f9703c',
        secondary: '#21002d',
        yellow: '#ffe12c',
        green: '#93bc48',
        blue: '#1ac5ff',
        orange: '#ff6c25',
        red: '#d91d2a',
    },
    variables: {
        margin: 10,
        padding: 10,
        borderRadius: '5px',
        maxWidth: 1200,
        baseFontSize: '14px',
    },
};
